import React, { useCallback, useEffect, useState } from 'react';
import { getCurrentUser } from 'aws-amplify/auth';
import { Authentication } from '../views/Authentication/index.js';
import Loading from '../components/Loading/index.js';
import { logger } from '../utils/logger.js';

export const withAuthentication = (WrappedComponent) => {
  return (props) => {
    const [isLoading, setIsLoading] = useState(true);
    const [isAuthenticated, setIsAuthenticated] = useState(false);

    const getAuthenticatedUser = useCallback(async () => {
      setIsLoading(true);
      try {
        await getCurrentUser();
        setIsAuthenticated(true);
      } catch (error) {
        logger.error('Error getting authenticated user', error);
        setIsAuthenticated(false);
      } finally {
        setIsLoading(false);
      }
    }, []);

    useEffect(() => {
      let isActive = true;

      if (isActive) {
        getAuthenticatedUser();
      }

      return () => {
        isActive = false;
      };
    }, [getAuthenticatedUser]);

    if (isLoading) {
      return <Loading />;
    }

    if (!isLoading && !isAuthenticated) {
      return <Authentication />;
    }

    return <WrappedComponent {...props} isAuthenticated={isAuthenticated} />;
  };
};
